import { useEffect, useState } from 'react';
import axios from 'axios';
import { apiUrl } from '../config/api';
import { fetchBrandImageUrl } from '../services/brandingService';

const useHeaderSettings = () => {
  const [officeEmail, setOfficeEmail] = useState('');
  const [officeNumber, setOfficeNumber] = useState('');
  const [logoUrl, setLogoUrl] = useState('');
  const [facebookLink, setFacebookLink] = useState('');
  const [whatsappLink, setWhatsappLink] = useState('');
  const [wechatLink, setWechatLink] = useState('');
  const [callLink, setCallLink] = useState('');

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const [emailRes, phoneRes, logoFromApi, socialRes] = await Promise.all([
          axios.get(apiUrl('/email-updates')),
          axios.get(apiUrl('/phone-updates')),
          fetchBrandImageUrl('logo'),
          axios.get(apiUrl('/social-links')),
        ]);

        emailRes.data?.forEach((setting) => {
          if (setting.type === 'office') {
            setOfficeEmail(setting.value);
          }
        });

        phoneRes.data?.forEach((setting) => {
          if (setting.type === 'office_number') {
            setOfficeNumber(setting.value);
          }
        });

        if (logoFromApi) {
          setLogoUrl(logoFromApi);
        }

        socialRes.data?.forEach((setting) => {
          if (setting.type === 'facebook') setFacebookLink(setting.value);
          if (setting.type === 'whatsapp') setWhatsappLink(setting.value);
          if (setting.type === 'wechat') setWechatLink(setting.value);
          if (setting.type === 'call') setCallLink(setting.value);
        });
      } catch (error) {
        console.error('Error fetching header settings:', error);
      }
    };

    fetchSettings();
  }, []);

  return {
    officeEmail,
    officeNumber,
    logoUrl,
    facebookLink,
    whatsappLink,
    wechatLink,
    callLink,
  };
};

export default useHeaderSettings;
